/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Deal_Splits_Fill_RemainingInputs */

const cs_deal_splits_fill_remaining = /** @type {(inputs: Deal_Splits_Fill_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Doplnit zbývajících ${i?.percent} %`)
};

const en_deal_splits_fill_remaining = /** @type {(inputs: Deal_Splits_Fill_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use remaining ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "Use remaining {percent}%" |
*
* @param {Deal_Splits_Fill_RemainingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_fill_remaining = /** @type {((inputs: Deal_Splits_Fill_RemainingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_Fill_RemainingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_fill_remaining(inputs)
	return cs_deal_splits_fill_remaining(inputs)
});